import { z } from "zod";

export const errorStoreSchema = z
  .object({
    errors: z.record(z.string(), z.string()).default({}),
    validatedFields: z.record(z.string(), z.array(z.string())).default({}),
    pageErrors: z.record(z.string(), z.string()).default({}),
  })
  .strip();

export type TErrorStoreData = z.infer<typeof errorStoreSchema>;

/**
 * Validates persisted error-store snapshots (field errors, validated fields, page errors).
 */
export function parseErrorStorePersistedSnapshot(raw: unknown) {
  return errorStoreSchema.safeParse(raw);
}
